import PropTypes from "prop-types";
import { ReactNode } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./TextInfo.module.scss";

interface IProps {
  textAlign?: "center" | "left" | "right";
  color?: string;
  fontFamily?:
    | "Poppins"
    | "Arial"
    | "Roboto"
    | "sans-serif"
    | "Helvetica"
    | "Open Sans"
    | "Montserrat"
    | "Lato"
    | "Georgia"
    | "Times New Roman"
    | "Courier New"
    | "Verdana"
    | "Tahoma"
    | "Noto Sans"
    | "Oswald"
    | "Merriweather";

  fontStyle?: "normal" | "italic" | "oblique";
  fontWeight?: "normal" | "bold" | "lighter" | "bolder" | number;
  fontSize?: number;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

const TextInfo = (props: IProps) => {
  const { fontSize = 16 } = props;
  const getColor = (color: string | undefined) => {
    switch (color) {
      case "success":
        return "#2FD664";
      case "danger":
        return "#D85454";
      case "light":
        return "#ffffff";
      case "primary":
        return "#2c62ae";
      case "gray":
        return "#9c9c9c";
      case "blue":
        return "#1E4894";
      default:
        return "#ffffff";
    }
  };

  return (
    <Row>
      <Col>
        <p
          className={[styles.textInfo, props.className].join(" ")}
          style={{
            textAlign: props.textAlign,
            color: getColor(props?.color),
            fontSize,
            fontFamily: props.fontFamily,
            fontStyle: props.fontStyle,
            fontWeight: props.fontWeight,
          }}
          onClick={props.onClick}
        >
          {props.children}
        </p>
      </Col>
    </Row>
  );
};

TextInfo.propTypes = {
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
  color: PropTypes.oneOf([
    "success",
    "danger",
    "light",
    "primary",
    "gray",
    "blue",
  ]),
  fontFamily: PropTypes.oneOf([
    "Poppins",
    "Arial",
    "Roboto",
    "sans-serif",
    "Helvetica",
    "Open Sans",
    "Montserrat",
    "Lato",
    "Georgia",
    "Times New Roman",
    "Courier New",
    "Verdana",
    "Tahoma",
    "Noto Sans",
    "Oswald",
    "Merriweather",
  ]),
  fontStyle: PropTypes.oneOf(["normal", "italic", "oblique"]),
  fontWeight: PropTypes.oneOfType([
    PropTypes.oneOf(["normal", "bold", "lighter", "bolder"]),
    PropTypes.number,
  ]),
};

export default TextInfo;
